import React from "react";
import AppXNLandingPage from "./XingnexLandingPage";

function App() {
  return <AppXNLandingPage />;
}

export default App;